/**
 * Main.js
 *
 * @since 1.0.0
 */

import 'smoothscroll'
import 'objectFitPolyfill'
import objectFitImages from 'object-fit-images'
// import Raven from 'raven-js'
import ObserveFontFace from './modules/ObserveFontFace'
import FormValidation from './modules/FormValidation'
import SendForm from './modules/SendForm'
import DependsOn from './modules/DependsOn'
import LazyLoadImage from './modules/LazyLoadImage'
import LazyLoadPicture from './modules/LazyLoadPicture'
import LazyLoadVideo from './modules/LazyLoadVideo'
import UploadButton from './modules/UploadButton'
import ReadMore from './modules/ReadMore'
import Video from './modules/Video'
import StickyHeader from './modules/StickyHeader'
import NavMobile from './modules/NavMobile'
import SearchMobile from './modules/SearchMobile'
import Toggle from './modules/Toggle'
import CalculatePrice from './woocommerce/CalculatePrice'
import DimensionsFeedback from './woocommerce/DimensionsFeedback'
import ShowOptions from './woocommerce/ShowOptions'
import ProductFilters from './woocommerce/ProductFilters'
import ProductFilterToggle from './woocommerce/ProductFilterToggle'
import MonitorVariationChange from './woocommerce/MonitorVariationChange'
import AddToCart from './datalayer/AddToCart'
import ChatActivity from './modules/ChatActivity'
import FillerMat from './modules/FillerMat'
import UpdateColorURL from './modules/UpdateColorURL'
import ScrollAnimation from './modules/ScrollAnimation'
import TriggerTarget from './modules/TriggerTarget'
import CheckoutFieldFocus from './modules/CheckoutFieldFocus'
import CheckoutFieldValues from './modules/CheckoutFieldValues'
import FaqToggle from './modules/FaqToggle'
import TargetClick from './modules/TargetClick'
import ParentClick from './modules/ParentClick'
import { toggleActiveClick } from './modules/Click'
// import ClassCheckWoocommerce from './modules/ClassCheckWoocommerce'
import CheckoutStepValidator from './modules/CheckoutStepValidator'
import AddProductPopup from './woocommerce/AddProductPopup'
import Message from './woocommerce/Message'
import ShoppingCart from './woocommerce/ShoppingCart'
import GalleryMenu from './modules/GalleryMenu'
import ThumbnailSlider from './modules/ThumbnailSlider'
import GoBack from './modules/GoBack'
import Swatches from './modules/Swatches'
import ProductSlider from './modules/ProductSlider'
import SingleProductSticky from './modules/SingleProductSticky'
import ProductSwatchesClick from './modules/ProductSwatchesClick'
import Lightbox from './modules/Lightbox'
import OpenSampleTab from './modules/OpenSampleTab'
import AddFillingMat from './modules/AddFillingMat'
import ItemSlider from './modules/ItemSlider'
import OpenPopup from './modules/OpenPopup'
import PdpRemoveDoubleElements from './modules/PdpRemoveDoubleElements'
import ProjectsSlider from './modules/ProjectsSlider'
import ProjectSliderMobile from './modules/ProjectSliderMobile'
import CheckoutBusiness from './modules/CheckoutBusiness'
// import CheckoutValidator from './modules/CheckoutValidator'
import CheckoutUpdatePrice from './modules/CheckoutUpdatePrice'
import HeaderSearch from './modules/HeaderSearch'
import ProductOptionRubber from './woocommerce/ProductOptionRubber'
import ProductFillingMat from './woocommerce/ProductFillingMat'
import ProductAdditionalProducts from './woocommerce/ProductAdditionalProducts'
import VariationBuitenmat from './woocommerce/VariationBuitenmat'
import CardsSlider from './modules/CardsSlider'
// import DataLayerPurchase from './modules/DataLayerPurchase'

// import HideChatIfCookie from './modules/HideChatIfCookie'
(function IIFE() {
  // Raven
  // .config('https://3c38a13f1d9c4d3fa0067e8973a5590e@sentry.io/1439045')
  // .install()
  ObserveFontFace()
  CheckoutBusiness()
  // CheckoutValidator()
  ProjectSliderMobile()
  ProjectsSlider()
  objectFitImages()
  FormValidation()
  SendForm()
  DependsOn()
  LazyLoadImage()
  LazyLoadPicture()
  LazyLoadVideo()
  UploadButton()
  ReadMore()
  Video()
  StickyHeader()
  NavMobile()
  SearchMobile()
  Toggle()
  CalculatePrice()
  DimensionsFeedback()
  ShowOptions()
  ProductFilters()
  ProductFilterToggle()
  MonitorVariationChange()
  AddToCart()
  ChatActivity()
  FillerMat()
  UpdateColorURL()
  TriggerTarget()
  // HideChatIfCookie()
  const scrollAnimate = new ScrollAnimation()
  scrollAnimate.start()
  CheckoutFieldFocus()
  CheckoutFieldValues()
  toggleActiveClick()
  TargetClick()
  ParentClick()
  // ClassCheckWoocommerce()
  CheckoutStepValidator()
  AddProductPopup()
  Message()
  ShoppingCart()
  GalleryMenu()
  ThumbnailSlider()
  GoBack()
  Swatches()
  ProductSlider()
  SingleProductSticky()
  ProductSwatchesClick()
  Lightbox()
  OpenSampleTab()
  AddFillingMat()
  ItemSlider()
  OpenPopup()
  PdpRemoveDoubleElements()
  CheckoutUpdatePrice()
  // DataLayerPurchase()
  HeaderSearch()
  ProductOptionRubber()
  ProductFillingMat()
  ProductAdditionalProducts()
  VariationBuitenmat()
  CardsSlider()
  FaqToggle()
})()



// WEBPACK FOOTER //
// ./src/js/main.js